var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "page-outline",
    { attrs: { title: _vm.$t("pacs008.sttngs") } },
    [
      _c(
        "template",
        { slot: "pageContent" },
        [
          _c(
            "b-form-group",
            [
              _c(
                "b-row",
                [
                  _c(
                    "b-col",
                    {
                      class: {
                        "active-setting": _vm.currentSetting === "left",
                        "inactive-setting": _vm.currentSetting !== "left",
                      },
                    },
                    [
                      _c(
                        "h5",
                        { staticClass: "h5 font-weight-bold pb-2 text-center" },
                        [_vm._v("Parametrer mes batchs")]
                      ),
                      _vm._v(" "),
                      _c("form-write-group-label-input", {
                        staticClass: "mb-3",
                        attrs: {
                          isMandatory: true,
                          inputLabel:
                            "Paramétrer la fréquence d éxécution des PACS_008",
                          inputType: "text",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.changeBackground("left")
                          },
                        },
                        model: {
                          value: _vm.time_settings,
                          callback: function ($$v) {
                            _vm.time_settings = $$v
                          },
                          expression: "time_settings",
                        },
                      }),
                      _vm._v(" "),
                      _c("form-write-group-label-input", {
                        staticClass: "mb-3",
                        attrs: {
                          isMandatory: true,
                          inputLabel: "Nb limite de transaction par fichiers",
                          inputType: "text",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.changeBackground("left")
                          },
                        },
                        model: {
                          value: _vm.transaction_settings,
                          callback: function ($$v) {
                            _vm.transaction_settings = $$v
                          },
                          expression: "transaction_settings",
                        },
                      }),
                    ],
                    1
                  ),
                  _vm._v(" "),
                  _c(
                    "b-col",
                    {
                      class: {
                        "active-setting": _vm.currentSetting === "right",
                        "inactive-setting": _vm.currentSetting !== "right",
                      },
                    },
                    [
                      _c(
                        "h5",
                        { staticClass: "h5 font-weight-bold pb-2 text-center" },
                        [_vm._v("Parametrer le SFTP")]
                      ),
                      _vm._v(" "),
                      _c("form-write-group-label-input", {
                        staticClass: "mb-3",
                        attrs: {
                          isMandatory: true,
                          inputLabel: "URL",
                          inputType: "text",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.changeBackground("right")
                          },
                        },
                        model: {
                          value: _vm.url_settings,
                          callback: function ($$v) {
                            _vm.url_settings = $$v
                          },
                          expression: "url_settings",
                        },
                      }),
                      _vm._v(" "),
                      _c("form-write-group-label-input", {
                        staticClass: "mb-3",
                        attrs: {
                          isMandatory: true,
                          inputLabel: "User",
                          inputType: "text",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.changeBackground("right")
                          },
                        },
                        model: {
                          value: _vm.user_settings,
                          callback: function ($$v) {
                            _vm.user_settings = $$v
                          },
                          expression: "user_settings",
                        },
                      }),
                      _vm._v(" "),
                      _c("form-write-group-label-input", {
                        staticClass: "mb-3",
                        attrs: {
                          isMandatory: true,
                          inputLabel: "Path",
                          inputType: "text",
                        },
                        on: {
                          click: function ($event) {
                            return _vm.changeBackground("right")
                          },
                        },
                        model: {
                          value: _vm.path_settings,
                          callback: function ($$v) {
                            _vm.path_settings = $$v
                          },
                          expression: "path_settings",
                        },
                      }),
                    ],
                    1
                  ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    2
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }